module.exports = __webpack_public_path__ + "img/tr-gas.ad0087bf.gif";